<template>
  <section class="content">
    <admin-header
      :title="'Spreadsheet Descriptors'"
      v-on:open-filter="openFilter"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:entity-quick-search="search"
      :disableQuickSearch="true"
    ></admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  import AdminHeader from '../AdminHeader'
  import SheetMixin from './SheetMixin'
  import event from '../../../../event'
  export default {
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    name: 'AdminSpreadsheetDescriptor',
    data () {
      return {
        newEntityScreen: 'Admin - Spreadsheet Descriptors',
        searchEntityScreen: 'Admin - Spreadsheet Descriptor search',
        filterEventName: 'admin-spreadsheet-descriptor-filter',
        filterName: 'SpreadsheetDescriptorFilter',
        entityName: 'spreadsheet-descriptor'
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/SpreadsheetDescriptor/AdminSpreadsheetDescriptor.vue